let amaModulesCache: any = null;

export default function getModules() {
  if (amaModulesCache) {
    return amaModulesCache;
  }
  
  amaModulesCache = {
      adTags: {},
      useLimitedAds: true,
      useLoadDmByAdsLib: true,
      useStats: true,
      useGLazyLoad: ['responsive_1', 'top_ad'],
      useFirstWaveBatching: false,
      useSingleRequest: false,
    };
 
  return amaModulesCache;
}
  